import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";

for (let i = 1; i <= $(".slider__content.vertical").length; i++) {
  let slider = $(".slider__content.vertical[data-id='" + i + "']");
  slider.owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    dots: true,
    animateOut: "slideOutUp",
    animateIn: "slideInUp",
    autoplay: true,
    autoplayTimeout: 8000,
  });
}
for (let i = 1; i <= $(".slider__content.horizontal").length; i++) {
  let slider = $(".slider__content.horizontal[data-id='" + i + "']");
  slider.owlCarousel({
    items: 3,
    loop: true,
    nav: false,
    dots: true,
    margin: 40,
    slideBy: 3,
    autoplay: true,
    smartSpeed: 1500,
    autoplayTimeout: 8000,
    responsive: {
      0: {
        items: 1,
      },
      576: {
        items: 2,
      },
      768: {
        margin: 10,
      },
      992: {
        margin: 20,
      },
      1200: {
        margin: 40,
      },
    },
  });
}
for (let i = 1; i <= $(".slider__content.horizontal-two").length; i++) {
  let slider = $(".slider__content.horizontal-two[data-id='" + i + "']");
  slider.owlCarousel({
    items: 2,
    loop: true,
    nav: false,
    dots: true,
    margin: 40,
    slideBy: 3,
    autoplay: true,
    smartSpeed: 1500,
    autoplayTimeout: 8000,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
        margin: 10,
      },
      992: {
        margin: 20,
      },
      1200: {
        margin: 40,
      },
    },
  });
}

for (let i = 1; i <= $(".gallery").length; i++) {
  let slider = $(".gallery[data-id='" + i + "']");
  slider.owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    dots: true,
    autoplay: true,
    smartSpeed: 1500,
    autoplayTimeout: 5000,
    animateOut: "fadeOut",
    animateIn: "fadeIn",
  });
}
